import React from 'react';
import { Flex, Form, Input, Button, message, Radio, DatePicker, TimePicker, InputNumber, Divider, Card } from 'antd';
import { TagOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons';
import SwitchShop from '../../shop/switch-shop';
import CardContent from '../../goods/card-content';
import GoodSelect from '../../goods/select-goods';
import { getCurrentShopId } from '../../shop/get-current-shop';

const urlParams = new URLSearchParams(window.location.search);

export default () => {
    const [shops, setShops] = React.useState([]);
    const [goods, setGoods] = React.useState([]);
    const [form] = Form.useForm(); 
    const [shopId, setShopId] = React.useState(null);
    const cardTmpId = urlParams.get('cardTmpId');
    const action = urlParams.get('action');

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        fetchShopId();
    }, []);

    React.useEffect(() => {
        if (!shopId) return;

        if (cardTmpId) {
            initForm();
        } else {
            form.setFieldsValue({
                skus: [{ cardId: 1, title: '两次卡', times: 2, price: 100 }]
            });
        }
    }, [shopId, cardTmpId]);

    const initForm = async () => {
        if(cardTmpId) {
            const values = await getCardDetail(cardTmpId);
            const goods = await getGoodsDetail(values.goodsId);
            values.skus = values.goods_card_skus;
            values.goodsId = [{ title: goods.title, goodsId: goods.goodsId }];
            form.setFieldsValue(values);
        }
    }

    const getCardDetail = async (cardTmpId) => { 
        if (!shopId) return;
        
        const response = await fetch(`/api/goods-card/detail?cardTmpId=${cardTmpId}&shopId=${shopId}`);
        const result = await response.json();

        if(result?.success) {
            if(result?.data?.goods_card_skus) {
                result.data.goods_card_skus = result.data.goods_card_skus.map(item => ({
                    ...item,
                    price: item.price / 100,
                }));
            }
            return result?.data;
        }else{
            message.error(result?.data);
        }
    }

    const getGoodsDetail = async (goodsId) => { 
        const response = await fetch(`/api/goods/detail?goodsId=${goodsId}`);
        const result = await response.json();

        if(result?.success) {
            return result?.data;
        }else{
            message.error(result?.data);
        }
    }

    const onSubmit = async () => { 
        if (!shopId) return;
        
        const url = action === 'edit' ? `/api/goods-card/update?cardTmpId=${cardTmpId}&shopId=${shopId}` : '/api/goods-card/create';
        const values = await form.validateFields();
        console.log('values', values);

        values.goodsId = values?.goodsId?.[0]?.goodsId;
        values.shopId = shopId;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        });

        const result = await response.json();

        if (result && result.success) { 
            message.success('添加成功');
            setTimeout(() => {
                window.location.href = '/promotion/goods-card-template';
            }, 500);
        }else{
            message.error(result.data);
        }
    };

    return (
        <div>
            <SwitchShop />
            <h2>{action === 'edit' ? '编辑' : '创建'}次卡</h2>
            <Form form={form}>
                <Form.Item 
                    label="次卡名称"
                    name="title"
                    rules={[{ required: true, message: '请输入次卡名称' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item 
                    label="选择商品"
                    name="goodsId"
                    rules={[{ required: true, message: '请选择商品' }]}
                >
                    <GoodSelect goodsType="NORMAL" />
                </Form.Item>

                <Form.Item 
                    label="描述"
                    name="description"
                >
                    <Input />
                </Form.Item>

                {/* <Form.Item 
                    label="适用商品"
                    name='goods'
                    rules={[{required: true, message: '至少选择一个商品'}]}
                >
                    <Card
                        title={'商品标题'}
                    >
                        <CardContent />
                        
                    </Card>
                    <Button style={{margin: '10px 0 0 0'}} onClick={() => {}}>{goods.length >= 1 ? '重新选择' : '选择商品'}</Button>
                </Form.Item> */}

                {/* <Form.Item
                    label="适用店铺"
                    name="shops"
                    rules={[{ required: true, message: '请选择店铺' }]}
                >
                    <Input type="hidden" />
                    {
                        shops && <List bordered dataSource={shops} renderItem={
                            (item) => <List.Item actions={[<a>删除</a>]} key={item.shopId}>{item.title}</List.Item>
                        } />
                    }
                    <Button style={{margin: '10px 0 0 0'}}>选择店铺</Button>
                </Form.Item> */}
                    
                <Form.List name='skus'>
                    {
                        (fields, {add, remove}) => (
                            <>
                                <Form.Item label="配置次卡">
                                    {
                                        fields.length > 0 && fields.map(({key, name}, index) => {
                                            // const originPrice = goods[0].price;

                                            return (
                                                <Flex key={key} gap={10} align='center'>
                                                    <Form.Item name={[name, 'title']}><Input placeholder='次卡名称' /></Form.Item>
                                                    <Form.Item name={[name, 'times']}><InputNumber placeholder='次数' addonAfter='次' /></Form.Item>
                                                    <Form.Item name={[name, 'price']}><InputNumber placeholder='价格' addonAfter='元' /></Form.Item>
                                                    <div onClick={() => remove(name)}><DeleteOutlined size={'large'} /></div>
                                                </Flex>
                                            )
                                        })
                                    }
                                    <div onClick={() => add()}><a>增加配置</a></div>
                                </Form.Item>
                            </>
                        )
                    }
                </Form.List>

                <Form.Item
                    label="次卡使用间隔时间"
                    name="intervalTime"
                    rules={[{ required: true, message: '请输入次卡使用间隔时间' }]}
                >
                    <InputNumber placeholder='请输入次卡使用间隔时间' addonAfter='天' />
                </Form.Item>

                <Form.Item
                    label="有效期"
                    name="validityDays"
                    rules={[{ required: true, message: '请输入有效期' }]}
                >
                    <InputNumber addonAfter='天' />
                </Form.Item>

                <Form.Item
                    label="线下销量"
                    name="offlineSaleNum"
                >
                    <InputNumber />
                </Form.Item>
            </Form>
            <Divider />
            <Flex justify='center' gap={10}>
                <Button>取消</Button>
                <Button type='primary' onClick={onSubmit}>提交</Button>
            </Flex>
        </div>
    )
}